import React, {useEffect, useState} from 'react';
import {Input, Button} from 'antd';
import {useSearchParams, useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import api from '../Interceptor';
const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'http://localhost:8011';
  
const SetUserPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  const [otpSent, setOtpSent] = useState(false);
    //   const [otp, setOtp] = useState('');
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const inputRefs = React.useRef([]);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // 🚀 Send OTP when page loads
  useEffect(() => {
    if (!token) {
      toast.error('Invalid or expired link');
      navigate('/');
      return;
    }

    const sendOtp = async () => {
      try {
        await api.post(`${API_BASE_URL}/api/v1/auth/send-otp-set-password`, {
          token,
        });
        setOtpSent(true);
        toast.success('OTP sent to your email');
      } catch (err) {
        toast.error(err?.response?.data?.error || 'Failed to send OTP');
      }
    };

    sendOtp();
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const otpValue = otp.join('');

    if (!otpValue || !password || !confirmPassword) {
      toast.error('All fields are required');
      return;
    }


    if (password.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      setLoading(true);

      await api.post(`${API_BASE_URL}/api/v1/auth/verify-otp-set-password`, {
        token,
        otp: otpValue,
        password,
      });

      toast.success('Password set successfully');
      navigate('/');
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to set password');
    } finally {
      setLoading(false);
    }
  };
const handleOtpChange = (value, index) => {
  if (/^[0-9]?$/.test(value)) {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  }
};

const handleOtpKeyDown = (e, index) => {
  if (e.key === 'Backspace' && !otp[index] && index > 0) {
    inputRefs.current[index - 1]?.focus();
  }
};

const handleOtpPaste = (e) => {
  e.preventDefault();
  const pasted = e.clipboardData.getData('text').trim();

  if (!/^\d+$/.test(pasted)) return;

  const digits = pasted.slice(0, 6).split('');
  const newOtp = [...otp];

  digits.forEach((d, i) => {
    newOtp[i] = d;
  });

  setOtp(newOtp);
  inputRefs.current[Math.min(digits.length, 5)]?.focus();
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold text-center mb-4">
          Set Your Password
        </h2>

        <p className="text-sm text-gray-600 text-center mb-6">
          We sent a verification code to your email
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            {/* <label className="block text-sm font-medium mb-1">OTP</label> */}
            <div className="flex justify-center gap-3">
              {otp.map((digit, i) => (
                <input
                  key={i}
                  ref={(el) => (inputRefs.current[i] = el)}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, i)}
                  onKeyDown={(e) => handleOtpKeyDown(e, i)}
                  onPaste={handleOtpPaste}
                  className="w-12 h-12 text-center text-xl font-semibold border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-themeColor"
                />
              ))}
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              New Password
            </label>
            <Input.Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium mb-1">
              Confirm Password
            </label>
            <Input.Password
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm password"
            />
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            disabled={!otpSent || otp.some((d) => d === '')}
          >
            Set Password
          </Button>
        </form>
      </div>
    </div>
  );
};

export default SetUserPassword;
